import { render, staticRenderFns } from "./DiseasesOverview.vue?vue&type=template&id=2de425c6&scoped=true"
import script from "./DiseasesOverview.vue?vue&type=script&lang=js"
export * from "./DiseasesOverview.vue?vue&type=script&lang=js"
import style0 from "./DiseasesOverview.vue?vue&type=style&index=0&id=2de425c6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de425c6",
  null
  
)

export default component.exports